export var ILayoutElement;
(function (ILayoutElement) {
    let IToggleButton;
    (function (IToggleButton) {
        /**
         * Return an instance of IToggleButton with the provided fields. Any field not
         * listed will be populated with an empty value (an empty array,
         * or undefined, whichever is valid for the type of the value.)
         */
        IToggleButton.build = (partial) => (Object.assign({}, (partial !== null && partial !== void 0 ? partial : {})));
    })(IToggleButton = ILayoutElement.IToggleButton || (ILayoutElement.IToggleButton = {}));
    /**
     * https:www.notion.so/faire/Logged-in-homepage-fbd0e84c89ca46e0b69c04aeff33bd01
     */
    let Type;
    (function (Type) {
        /**
         * https:www.notion.so/faire/Logged-in-homepage-fbd0e84c89ca46e0b69c04aeff33bd01#fdbdaae8355e48efb23307335c0d5e23
         * These are the main value propositions. The element is too complex for us to return specifications for it.
         * The frontend is supposed to know how to render this element.
         */
        Type["MAIN_VALUE_PROPS"] = "MAIN_VALUE_PROPS";
        /**
         * https:www.notion.so/faire/Logged-in-homepage-fbd0e84c89ca46e0b69c04aeff33bd01#f2024139b77c4275b0e2f29ab6184987
         * This is one of the simplest elements, it's just a carousel of small brand tiles.
         */
        Type["SMALL_MAKER_TILE_CAROUSEL"] = "SMALL_MAKER_TILE_CAROUSEL";
        /**
         * https:www.notion.so/faire/Logged-in-homepage-fbd0e84c89ca46e0b69c04aeff33bd01#bed5d35bf50c440ca788c04ac72df98d
         * This should be one of the more versatile elements.
         */
        Type["IN_PAGE_IMAGE"] = "IN_PAGE_IMAGE";
        /**
         * https:www.figma.com/file/YKwphR5HRRn7DyLRipc8uN/FSM-'22-Retailer-Experience?node-id=804%3A12364
         */
        Type["IN_PAGE_IMAGE_SECONDARY"] = "IN_PAGE_IMAGE_SECONDARY";
        /**
         * https:www.notion.so/faire/Logged-in-homepage-fbd0e84c89ca46e0b69c04aeff33bd01#030ccfe44f1f414c9a2e9ed4c805f8d0
         * This element looks very similar to the brand carousel but contains flash sales instead.
         */
        Type["SMALL_FLASH_SALE_CAROUSEL"] = "SMALL_FLASH_SALE_CAROUSEL";
        /**
         * https:www.figma.com/file/8Ttp9nIOACEpoh1kPhfSiW/Treasure-Hunt-v1?node-id=78%3A8926
         * Large tile with information for a single maker displayed in a carousel format.
         * Currently used on mobile only.
         */
        Type["LARGE_MAKER_TILE"] = "LARGE_MAKER_TILE";
        /**
         * https:www.notion.so/faire/R2B-entry-points-in-app-10db50215f14429d89f4883db9ab7324
         * Used for R2B entry points
         * This type is NOT supported by clients and is for INTERNAL usage ONLY.
         */
        Type["R2B_ENTRY_POINT"] = "R2B_ENTRY_POINT";
        /**
         * https:www.notion.so/faire/Apparel-C1-Homepage-9e8a310df46d40a9bb54d7124ad3b4cf
         * https:www.figma.com/file/vRIxmI7iQ25PCxiuX4uJCO/Apparel-C1-Homepage?node-id=235%3A3653
         * Element for displaying a products carousel that has tiles similar/same to products-first-cat-nav
         */
        Type["PRODUCT_TILE_CAROUSEL"] = "PRODUCT_TILE_CAROUSEL";
        /**
         * https:www.notion.so/faire/Apparel-C1-Homepage-9e8a310df46d40a9bb54d7124ad3b4cf
         * https:www.notion.so/faire/Treatment-bucket-details-881964f845f94ee5bdea9293e4c73857#c9c93c9a37d94d82b8d88eda0a913255
         * Carousel of categories with portrait images instead of landscape
         * Also used at
         * https:www.notion.so/faire/Redesign-filtering-experience-Browse-bfea4633995b4d8d9fdb22708f0d14ae#3cef2d8c709e4eafbebdf7ebbdf5d3a8
         * https:www.figma.com/file/oV3rDne164xbSujsZlDutA/apparel-visual-navigation?node-id=828%3A60190
         * https:www.figma.com/file/nMAgBhL6oxN8dZr6zJxSAS/Showroom-v2?node-id=628%3A56250
         */
        Type["TALL_CATEGORY_TILE"] = "TALL_CATEGORY_TILE";
        /**
         * https:www.notion.so/faire/Apparel-C1-Homepage-9e8a310df46d40a9bb54d7124ad3b4cf
         * https:www.notion.so/faire/Treatment-bucket-details-881964f845f94ee5bdea9293e4c73857#c9c93c9a37d94d82b8d88eda0a913255
         * Carousel of categories with smaller tiles
         */
        Type["SMALL_CATEGORY_TILE"] = "SMALL_CATEGORY_TILE";
        /**
         * https:www.figma.com/file/A71waWpOl5FioDHdiBIzF1/Contextual-education-in-mobile-app?node-id=174%3A959
         * Testimonial tile currently for mobile app home feed only
         * Matches TestimonialTile.
         * @deprecated
         */
        Type["TESTIMONIAL"] = "TESTIMONIAL";
        /**
         * https:www.notion.so/faire/Redesign-filtering-experience-Browse-bfea4633995b4d8d9fdb22708f0d14ae#ce5849da02004d3294c088d01471574b
         * https:www.figma.com/file/oV3rDne164xbSujsZlDutA/apparel-visual-navigation?node-id=828%3A60190
         * Carousel of categories with circular images
         */
        Type["CIRCULAR_CATEGORY_TILE"] = "CIRCULAR_CATEGORY_TILE";
        /**
         * https:www.figma.com/file/A71waWpOl5FioDHdiBIzF1/Contextual-education-in-mobile-app?node-id=203%3A1165
         * Dismissable banner on top of category and search pages
         */
        Type["DISMISSABLE_TOP_BANNER"] = "DISMISSABLE_TOP_BANNER";
        /**
         * https:whimsical.com/new-retailer-logged-in-homepage-QFEgtWyoPr7E1gv8F3CUUg
         * Homepage app download banner for FE to populate the content
         */
        Type["HOMEPAGE_APP_DOWNLOAD_BANNER"] = "HOMEPAGE_APP_DOWNLOAD_BANNER";
        /**
         * https:www.figma.com/file/BvAqRhjm9Dms9LvErvwzEY/New-retailer-logged-in-homepage?node-id=696%3A10651
         * A plain text banner highlighting a promotional discount with an expiration date/time.
         * This type is NOT supported by clients and is for INTERNAL usage ONLY.
         */
        Type["PROMOTIONAL_DISCOUNT_BANNER"] = "PROMOTIONAL_DISCOUNT_BANNER";
        /**
         * https:www.figma.com/file/BvAqRhjm9Dms9LvErvwzEY/New-retailer-logged-in-homepage?node-id=779%3A13997
         * Homepage banner with suggested searches and images
         */
        Type["HOMEPAGE_SEARCH_QUERIES_BANNER"] = "HOMEPAGE_SEARCH_QUERIES_BANNER";
        /**
         * A grid of product tiles list for cat-nav or browse page. This type is NOT supported by client and is
         * for INTERNAL usage ONLY.
         */
        Type["PRODUCT_TILE_GRID"] = "PRODUCT_TILE_GRID";
        /**
         * https:www.figma.com/file/hfScsfxitzaGgIpMlCAYI5/MPP-Marketplace?node-id=1400%3A29703
         * Category homepage header banner for mid price point plus marketplace
         */
        Type["MID_PRICE_POINT_PLUS_CATEGORY_HOME_PAGE_HEADER_BANNER"] = "MID_PRICE_POINT_PLUS_CATEGORY_HOME_PAGE_HEADER_BANNER";
        /**
         * https:www.figma.com/file/hfScsfxitzaGgIpMlCAYI5/MPP-Marketplace?node-id=463%3A6198
         * Banner shows mid price point plus products to shop
         */
        Type["SHOP_MID_PRICE_POINT_PLUS_PRODUCTS_BANNER"] = "SHOP_MID_PRICE_POINT_PLUS_PRODUCTS_BANNER";
        /**
         * https:www.figma.com/file/hfScsfxitzaGgIpMlCAYI5/MPP-Marketplace?node-id=1686%3A27609
         * Mid price point plus marketplace page title on c3 category page and search page,
         * it shows up when MPP+ filter is applied.
         */
        Type["MID_PRICE_POINT_PLUS_PAGE_TITLE"] = "MID_PRICE_POINT_PLUS_PAGE_TITLE";
        /**
         * https:www.figma.com/file/byIl3UHFCP7cdPTN3zJ8Mw/Evergreen-Preorder-Visibility?node-id=1313%3A13747
         */
        Type["PRODUCT_IMAGE_CAROUSEL"] = "PRODUCT_IMAGE_CAROUSEL";
        /**
         * https:www.figma.com/file/byIl3UHFCP7cdPTN3zJ8Mw/Evergreen-Preorder-Visibility?node-id=1278%3A14961
         */
        Type["LARGE_PRODUCT_GRID"] = "LARGE_PRODUCT_GRID";
        /**
         * https:www.notion.so/faire/BE-Scoping-f3a2e3857db4473b9029c7dd613d16c2#ada779a95c3d4e2a8b935038c5d69441
         */
        Type["HIGHLIGHTED_PRODUCTS_CAROUSEL"] = "HIGHLIGHTED_PRODUCTS_CAROUSEL";
        /**
         * https:www.figma.com/file/hfScsfxitzaGgIpMlCAYI5/MPP-Marketplace?node-id=3129%3A37122
         * A simple banner with only one mainText and one descriptionText
         * The browse pod took over this text banner and modified it to this format.
         * https:www.figma.com/file/acGGYdQ1JMiFe0KY1ZLgDG/Special-Occasions?type=design&node-id=5957-103188&mode=dev
         */
        Type["SIMPLE_TEXT_BANNER"] = "SIMPLE_TEXT_BANNER";
        /**
         * Banner under `European Brands` category to promote European brands for retailers; designs here:
         * https:www.figma.com/file/HGw9T0xeGz925mEOaL9B7p/European-Brand-Discovery-for-US-retailers?node-id=572%3A62825
         */
        Type["SHOP_EUROPE_EDUCATIONAL_BANNER"] = "SHOP_EUROPE_EDUCATIONAL_BANNER";
        /**
         * Mobile homepage feed for reorders; designs here:
         * https:www.figma.com/file/bzCPM5soj0OkW9Xp6ARdfg/My-Brands?node-id=2657%3A75857
         */
        Type["REORDER_HOMEFEED_CAROUSEL"] = "REORDER_HOMEFEED_CAROUSEL";
        /**
         * Showroom page core value props with C2;
         * Designs here:
         * https:www.figma.com/file/nMAgBhL6oxN8dZr6zJxSAS/Showroom-v2?node-id=628%3A56250
         */
        Type["SHOWROOM_CORE_VALUE_PROPS_WITH_C2"] = "SHOWROOM_CORE_VALUE_PROPS_WITH_C2";
        /**
         * Showroom page illustrate vetting criteria banner;
         * Designs here:
         * https:www.figma.com/file/nMAgBhL6oxN8dZr6zJxSAS/Showroom-v2?node-id=628%3A56250
         */
        Type["SHOWROOM_ILLUSTRATE_VETTING_CRITERIA_BANNER"] = "SHOWROOM_ILLUSTRATE_VETTING_CRITERIA_BANNER";
        /**
         * Showroom page editorialized categories;
         * Designs here:
         * https:www.figma.com/file/nMAgBhL6oxN8dZr6zJxSAS/Showroom-v2?node-id=628%3A56250
         */
        Type["SHOWROOM_EDITORIALIZED_CATEGORIES"] = "SHOWROOM_EDITORIALIZED_CATEGORIES";
        /**
         * Showroom page featured brands;
         * Designs here:
         * https:www.figma.com/file/nMAgBhL6oxN8dZr6zJxSAS/Showroom-v2?node-id=628%3A56250
         */
        Type["SHOWROOM_FEATURED_BRANDS"] = "SHOWROOM_FEATURED_BRANDS";
        /**
         * Showroom page highlight brand banner;
         * Designs here:
         * https:www.figma.com/file/nMAgBhL6oxN8dZr6zJxSAS/Showroom-v2?node-id=628%3A56250
         */
        Type["SHOWROOM_HIGHLIGHT_BRAND_BANNER"] = "SHOWROOM_HIGHLIGHT_BRAND_BANNER";
        /**
         * Showroom page vetting criteria;
         * Designs here:
         * https:www.figma.com/file/nMAgBhL6oxN8dZr6zJxSAS/Showroom-v2?node-id=628%3A56250
         */
        Type["SHOWROOM_VETTING_CRITERIA"] = "SHOWROOM_VETTING_CRITERIA";
        /**
         * A showroom page title banner contains showroom values on mobile app
         * Designs here:
         * https:www.figma.com/file/nMAgBhL6oxN8dZr6zJxSAS/Showroom-v2?node-id=309%3A39825
         */
        Type["SHOWROOM_VALUES_TITLE_BANNER"] = "SHOWROOM_VALUES_TITLE_BANNER";
        /**
         * A PDP/brand page inline banner contains showroom values on mobile app
         * Designs here:
         * https:www.figma.com/file/nMAgBhL6oxN8dZr6zJxSAS/Showroom-v2?node-id=309%3A38096
         * https:www.figma.com/file/nMAgBhL6oxN8dZr6zJxSAS/Showroom-v2?node-id=309%3A40288
         */
        Type["SHOWROOM_VALUES_PROPS_INLINE_BANNER"] = "SHOWROOM_VALUES_PROPS_INLINE_BANNER";
        /**
         * Showroom returning user page, featured showroom products carousel
         * Designs here:
         * https:www.figma.com/file/nMAgBhL6oxN8dZr6zJxSAS/Showroom-v2?node-id=1826%3A81915
         */
        Type["SHOWROOM_FEATURED_PRODUCTS_CAROUSEL"] = "SHOWROOM_FEATURED_PRODUCTS_CAROUSEL";
        /**
         * Showroom returning user page, trending showroom products carousel
         * Designs here:
         * https:www.figma.com/file/nMAgBhL6oxN8dZr6zJxSAS/Showroom-v2?node-id=2724%3A93352
         */
        Type["SHOWROOM_TRENDING_PRODUCTS_CAROUSEL"] = "SHOWROOM_TRENDING_PRODUCTS_CAROUSEL";
        /**
         * Represents a collection of LeanProductWithBrandTile, i.e. a product tile with a brand section on the bottom.
         * https:www.figma.com/file/AeF21BMh8kVZAT1n58GpfQ/FFWv2-%E2%80%93--Retailer-Handoff?node-id=2510%3A36232
         * Note that some clients might prefer to render this as a LeanProductTile to avoid clutter.
         */
        Type["LEAN_PRODUCT_WITH_BRAND_TILE_CAROUSEL"] = "LEAN_PRODUCT_WITH_BRAND_TILE_CAROUSEL";
        /**
         * Represents a message carousel to show lifecycle banners for mobile homepage.
         * https:www.figma.com/file/psY2yAQaFYI3IS9YmjpfjQ/App-Home-2.0?node-id=2216%3A117384
         * @deprecated
         */
        Type["HOME_PAGE_MESSAGE_CAROUSEL"] = "HOME_PAGE_MESSAGE_CAROUSEL";
        /**
         * Used on explore page to render related searches query pills.
         * https:www.figma.com/file/Qz0NDlHgvUMIckhIjNXE30/Explore-Pages-Design-(v2)?node-id=563%3A41256
         */
        Type["SEARCH_QUERIES_CAROUSEL"] = "SEARCH_QUERIES_CAROUSEL";
        /**
         * Filter pills for a corresponding search keyword
         * https:www.figma.com/file/Qz0NDlHgvUMIckhIjNXE30/Explore-Pages-Design-(v2)?node-id=576%3A56728
         */
        Type["SEARCH_FILTER_PILLS"] = "SEARCH_FILTER_PILLS";
        /**
         * Used to render faire gift guide section.
         * https:www.figma.com/file/Qz0NDlHgvUMIckhIjNXE30/Explore-Pages-Design-(v2)?node-id=563%3A47888
         */
        Type["GIFT_GUIDE_TILE"] = "GIFT_GUIDE_TILE";
        /**
         * Used to render a carousel of testimonials.
         * https:www.figma.com/file/Qz0NDlHgvUMIckhIjNXE30/Explore-Pages-Design-(v2)?node-id=563%3A47472
         */
        Type["TESTIMONIAL_CAROUSEL"] = "TESTIMONIAL_CAROUSEL";
        /**
         * Represents a welcome element.
         * https:www.figma.com/file/psY2yAQaFYI3IS9YmjpfjQ/App-Home-2.x?node-id=549%3A25679
         */
        Type["MOBILE_WELCOME_CATEGORIES"] = "MOBILE_WELCOME_CATEGORIES";
        /**
         * Used for rendering the Insider upsell carousel on homepage as part of Insider Universal Framework
         * https:www.figma.com/file/HfEQVACpqhZIoLXyt0NAqF/Universal-Insider-Framework?node-id=6631%3A199177
         * This type is NOT supported by clients and is for INTERNAL usage ONLY.
         */
        Type["INSIDER_HOMEPAGE_UPSELL_CAROUSEL"] = "INSIDER_HOMEPAGE_UPSELL_CAROUSEL";
        /**
         * Used to show retailer brand insights carousel on the homepage.
         * https:www.figma.com/file/p3jLRuYGsFkhdvRhSPQfK1/Reorder-updates-hub-%5BReorder%5D?node-id=2085%3A143521
         */
        Type["RETAILER_BRAND_INSIGHTS_CAROUSEL"] = "RETAILER_BRAND_INSIGHTS_CAROUSEL";
        /**
         * Used to show the retailer their recent searched terms on the homepage.
         * https:www.figma.com/file/EpPi2pK16BV0gJP4WD60is/Saved-searches-%26-Jump-back-In?node-id=2207%3A76837
         */
        Type["RECENT_SEARCHES_CAROUSEL"] = "RECENT_SEARCHES_CAROUSEL";
        /**
         * This is a carousel type that will show brands that a retailer can sample.
         * Part of the SAMPLES product area
         * https:www.figma.com/file/Etra91XngZRaM21UG4lX5L/Food-%26-Beverage-Samples?node-id=4635%3A95198&t=jfuVEXdF4qiy1zOz-0
         */
        Type["SAMPLE_REQUEST_CAROUSEL"] = "SAMPLE_REQUEST_CAROUSEL";
        /**
         * Used to show products that a retailer sampled.
         * Part of the SAMPLES product area
         * https:www.figma.com/file/Etra91XngZRaM21UG4lX5L/Food-%26-Beverage-Samples?node-id=5297%3A117161&t=Ik9UVigAz911gQ6H-0
         */
        Type["BUY_FROM_SAMPLES_CAROUSEL"] = "BUY_FROM_SAMPLES_CAROUSEL";
        /**
         * A vertically expandable product grid for the shopping loops project.
         * https:www.figma.com/file/LSlw27H95cN8QgKmAJpke5/Shopping-loops-on-PDP?node-id=3684%3A133066&t=4Wl9ltHaUYTUbvjR-0
         */
        Type["VERTICALLY_EXPANDABLE_PRODUCT_GRID"] = "VERTICALLY_EXPANDABLE_PRODUCT_GRID";
        /**
         * This element is a no op placeholder. Clients should not render anything when they encounter this
         * type. However, they should still respect the layoutElementDataAssignSettingsOnClientView field. This allows us to
         * do correct bucketing on experiments that remove or add elements to a particular layout.
         */
        Type["NO_OP_LAYOUT_ELEMENT"] = "NO_OP_LAYOUT_ELEMENT";
        /**
         * A Carousel containing grid tiles, designed for product based collections
         * https:www.figma.com/file/oUVZghhJIL3cAhJO6VC4vJ/Discovering-Fresh-Apparel-%2F-Collection-Launch-drops?node-id=552%3A94727&t=W0HZi5Z7RbR5OQFe-0
         * @deprecated
         */
        Type["GRID_TILE_CAROUSEL"] = "GRID_TILE_CAROUSEL";
        /**
         * Used to display the most popular brands in a region on logged out suppliers pages
         * https:www.notion.so/faire/New-page-type-Brand-results-pages-dbef9fff47054ae0bf45aed259ffe0e7?pvs=4#2c833bc37d6b4fdf9dee6a913df891ac
         */
        Type["MOST_POPULAR_BRANDS"] = "MOST_POPULAR_BRANDS";
        /**
         * use to display mobile pills on mobile web
         */
        Type["MOBILE_WEB_PILLS"] = "MOBILE_WEB_PILLS";
        /**
         * use to display category banner
         */
        Type["COMMUNITY_CATEGORY_BANNER"] = "COMMUNITY_CATEGORY_BANNER";
        /**
         * https:www.figma.com/file/ThPbgnU0IA0MbDDVpFsxPf/Warehouse-Sale?node-id=4526-10676&t=exoKgLV3BVpS8X3Q-4
         * This element looks very similar to the SMALL_FLASH_SALE_CAROUSEL, tweaked for seasonal warehouse sale
         */
        Type["WAREHOUSE_SALE_CAROUSEL"] = "WAREHOUSE_SALE_CAROUSEL";
        /**
         * https:www.figma.com/file/mVJQw4r8Oj2RMIDynzcigE/%E2%98%80%EF%B8%8F-Faire-Summer-Market-2023?type=design&node-id=3095-74557&t=fjtAO3GqQycadNLQ-0
         * This element is for mobile to create custom formatted pre-show homepage banners for Markets
         */
        Type["FAIRE_MARKETS_PRE_SHOW_BANNER"] = "FAIRE_MARKETS_PRE_SHOW_BANNER";
        /**
         * https:www.figma.com/file/mVJQw4r8Oj2RMIDynzcigE/%E2%98%80%EF%B8%8F-Faire-Summer-Market-2023?type=design&node-id=3095-74557&t=fjtAO3GqQycadNLQ-0
         * This element is for mobile to create custom formatted hero homepage banners for Markets
         */
        Type["FAIRE_MARKETS_HERO_BANNER"] = "FAIRE_MARKETS_HERO_BANNER";
        /**
         * https:www.figma.com/file/wqHPF7FIpRnpkgc2HnZqil/Team%2C-permission%2C-and-collaborative-bag-education?type=design&node-id=692-446961&t=aOS73lKywD47N5WT-0
         * A banner used to educate retailer sub-users about their permissions and their team
         */
        Type["RETAILER_MULTI_USER_TEAM_EDUCATION_BANNER"] = "RETAILER_MULTI_USER_TEAM_EDUCATION_BANNER";
        /**
         * Used to display grids of various layout element data types, example: gift guide banner on holiday shop page
         * https:www.figma.com/file/acGGYdQ1JMiFe0KY1ZLgDG/Special-Occasions?node-id=4796%3A79865&mode=dev
         * @deprecated
         */
        Type["DYNAMIC_GRID"] = "DYNAMIC_GRID";
        /**
         * Used to display various marketing banners, example: Stock up for Holidays banner from homepage
         * https:www.figma.com/file/acGGYdQ1JMiFe0KY1ZLgDG/Special-Occasions?type=design&node-id=5476-90057&mode=dev
         */
        Type["MARKETING_BANNER"] = "MARKETING_BANNER";
        /**
         * Used to display the full width image header, example: holiday shop page image header
         * https:www.figma.com/file/acGGYdQ1JMiFe0KY1ZLgDG/Special-Occasions?type=design&node-id=5476-88749&mode=dev
         */
        Type["FULL_WIDTH_IMAGE_BANNER"] = "FULL_WIDTH_IMAGE_BANNER";
        /**
         * Used to display a callout for Spa & Salon retailers
         * https:www.figma.com/file/YHp4AyuAXlRWNoDFxhyP8x/Partial-Retailers---Design-Opps?node-id=462%3A68837&mode=dev
         * @deprecated
         */
        Type["SPA_SALON_RETAILER_CALLOUT"] = "SPA_SALON_RETAILER_CALLOUT";
        /**
         * Used to display an explanation of Faire's eco-friendly product attributes
         * https:www.figma.com/file/CQBNDWn5ukts0FRi9EvikO/Sustainability-page?type=design&node-id=1870-170092&mode=dev
         */
        Type["ECO_FRIENDLY_DEFINITION_BANNER"] = "ECO_FRIENDLY_DEFINITION_BANNER";
        /**
         * Used to display a small GTM promo banner on the Category Page
         */
        Type["SMALL_DISMISSABLE_PROMO_BANNER"] = "SMALL_DISMISSABLE_PROMO_BANNER";
        /**
         * Used to display Avatar Carousel (Logged out Visual Nav)
         * https:www.figma.com/file/gzAnBXkVaDKZZ1vYrm3iHm/2023-Q3-Quality-Issues-Support-SEO?type=design&node-id=268-20538&mode=design&t=SMhTvpuzKikfYO31-0
         */
        Type["AVATAR_CAROUSEL"] = "AVATAR_CAROUSEL";
        /**
         * Used to display Avatar Carousel And Avatar Grid on MWeb (Logged out Visual Nav)
         * https:www.figma.com/file/gzAnBXkVaDKZZ1vYrm3iHm/2023-Q3-Quality-Issues-Support-SEO?type=design&node-id=268-20538&mode=design&t=SMhTvpuzKikfYO31-0
         */
        Type["AVATAR_CAROUSEL_WITH_GRID"] = "AVATAR_CAROUSEL_WITH_GRID";
        /**
         * Used to display grids or carousel of various layout element data types, example: holiday shop page banners
         * https:www.figma.com/file/52DuPaecpzwgu59Z2ebvSZ/Special-Occasions---V2?type=design&node-id=5728-140790&mode=design&t=BesPO3nWWaYeKr6q-0
         */
        Type["DYNAMIC_GRID_OR_CAROUSEL"] = "DYNAMIC_GRID_OR_CAROUSEL";
        /**
         * Used to display the multi image header, example: holiday shop page image header
         * https:www.figma.com/file/52DuPaecpzwgu59Z2ebvSZ/Special-Occasions---V2?type=design&node-id=6152-67247&mode=design&t=7VfCpCf5hjQrueNy-0
         */
        Type["MULTI_IMAGE_TITLE_BANNER"] = "MULTI_IMAGE_TITLE_BANNER";
        /**
         * Used to display dynamic or alternating grids of various layout element data types, example: gift guide banner on holiday shop page
         * Web desktop currently uses dynamic grid while Mobile Web/App uses alternating grid
         * https:www.figma.com/file/52DuPaecpzwgu59Z2ebvSZ/Special-Occasions---V2?type=design&node-id=6152-67247&mode=design&t=N0mkOEMmpjK3YAck-0
         * @deprecated
         */
        Type["DYNAMIC_OR_ALTERNATING_GRID"] = "DYNAMIC_OR_ALTERNATING_GRID";
        /**
         * Used to display the banner for new brands with free shipping offer
         * https:www.figma.com/file/kWp8Y1nViYLSxAyUrx8EGi/Replace-insider-free-shipping-benefit-for-new-brands?type=design&node-id=4444%3A64181&mode=design&t=zizRLKAr5eISc1Ij-1
         */
        Type["NEW_BRANDS_FREE_SHIPPING_BANNER"] = "NEW_BRANDS_FREE_SHIPPING_BANNER";
        /**
         * Used to display the filterable carousel on the homepage
         * https:www.figma.com/file/XBKfeoIzmZdUqB0dyDeq1z/Homepage-strategy-2024?type=design&node-id=8271-44301&mode=design&t=qHvYJ5163O3HMujn-0
         * @deprecated
         */
        Type["HOMEPAGE_FILTERABLE_CAROUSEL"] = "HOMEPAGE_FILTERABLE_CAROUSEL";
        /**
         * Used to display dynamic and sparse grids of various layout element data types, example: gift guide banner on holiday shop page
         * https:www.figma.com/file/3I5Wiw0SQkHAN4zrDLpaWf/Tiered-browse-framework?type=design&node-id=828%3A58974&mode=dev&t=7eo9zPkXRFuJibXN-1
         */
        Type["DYNAMIC_SPARSE_GRID"] = "DYNAMIC_SPARSE_GRID";
        /**
         * Used by Browse Hub's homepage promotional banner. Similar to marketing banner, but it has different design on
         * mobile web vs desktop
         * https:www.figma.com/file/3I5Wiw0SQkHAN4zrDLpaWf/Tiered-browse-framework?type=design&node-id=1563-108318&mode=design&t=w5oPh7e7v3WPJt7N-4
         */
        Type["BROWSE_HOMEPAGE_PROMOTIONAL_BANNER"] = "BROWSE_HOMEPAGE_PROMOTIONAL_BANNER";
        /**
         * Used to display a horizontal line
         */
        Type["HORIZONTAL_LINE"] = "HORIZONTAL_LINE";
        /**
         * Used to display a single button
         */
        Type["BUTTON"] = "BUTTON";
        /**
         * A section containing a brand header and multiple product tiles, used for the digest page
         */
        Type["DIGEST_PAGE_BRAND_SPOTLIGHT_SECTION"] = "DIGEST_PAGE_BRAND_SPOTLIGHT_SECTION";
        /**
         * A section containing 3 images in a collage format, used for the digest page
         */
        Type["IMAGE_COLLAGE"] = "IMAGE_COLLAGE";
        /**
         * A breadcrumb list or placeholder for breadcrumb position.
         */
        Type["BREADCRUMB"] = "BREADCRUMB";
        /**
         * Grid for category tiles, with extra padding on the top. Example: browse landing page for you grid
         */
        Type["CATEGORY_TILE_GRID"] = "CATEGORY_TILE_GRID";
        /**
         * Displays a grid of components forming the header for the digest page
         */
        Type["DIGEST_PAGE_HEADER_GRID"] = "DIGEST_PAGE_HEADER_GRID";
        /**
         * Displays a grid of components forming the header for the digest page
         */
        Type["DIGEST_PAGE_HEADER_BANNER"] = "DIGEST_PAGE_HEADER_BANNER";
        /**
         * A brand header component on the digest page
         */
        Type["DIGEST_PAGE_BRAND_HEADER"] = "DIGEST_PAGE_BRAND_HEADER";
    })(Type = ILayoutElement.Type || (ILayoutElement.Type = {}));
    /**
     * Where to display the layout element.
     */
    let DisplayPage;
    (function (DisplayPage) {
        /**
         * @deprecated
         */
        DisplayPage["LANDING_PAGE"] = "LANDING_PAGE";
        /**
         * @deprecated
         */
        DisplayPage["FLASH_SALE_PAGE"] = "FLASH_SALE_PAGE";
        /**
         * This is only used directly in the home feed api. should be ignored by everyone else.
         */
        DisplayPage["HOME_FEED"] = "HOME_FEED";
        DisplayPage["CATEGORY_PAGE"] = "CATEGORY_PAGE";
        /**
         * HOMEPAGE will replace LANDING_PAGE if experiment succeeds
         */
        DisplayPage["HOMEPAGE"] = "HOMEPAGE";
        /**
         * Deprecated after new FAIRE_MARKET_HOMEPAGE_V2
         * @deprecated
         */
        DisplayPage["FAIRE_MARKET_HOMEPAGE"] = "FAIRE_MARKET_HOMEPAGE";
        DisplayPage["SHOWROOM_PAGE"] = "SHOWROOM_PAGE";
        /**
         * HOMEPAGE_FALLBACK will only be used while `IMPROVED_HOMEPAGE_RELEVANCE_220503` is launched,
         * to serve the old homepage to Mobile App. This will be deprecated when Mobile Homepage V2 enter 100% phase 1A.
         * More context: https:www.notion.so/faire/Homepage-Relevance-Mobile-Sync-9242a3ef0d574d34b71cc84dee52fa68#d8b306064d454ee89b46b4c27fc5c9bd
         * @deprecated
         */
        DisplayPage["HOMEPAGE_FALLBACK"] = "HOMEPAGE_FALLBACK";
        /**
         * FFW showtime takeover of the web homepage
         * @deprecated
         */
        DisplayPage["FASHION_WEEK_HOMEPAGE_WEB"] = "FASHION_WEEK_HOMEPAGE_WEB";
        /**
         * FFW showtime takeover of the app home feed
         * @deprecated
         */
        DisplayPage["FASHION_WEEK_HOME_FEED_APP"] = "FASHION_WEEK_HOME_FEED_APP";
        /**
         * Replaces HOMEPAGE during Markets showtime
         */
        DisplayPage["FAIRE_MARKET_HOMEPAGE_V2"] = "FAIRE_MARKET_HOMEPAGE_V2";
        DisplayPage["CART_PAGE"] = "CART_PAGE";
        DisplayPage["SUPPLIERS_PAGE"] = "SUPPLIERS_PAGE";
        DisplayPage["PRODUCT_PAGE"] = "PRODUCT_PAGE";
        DisplayPage["SIMILAR_PRODUCTS_PAGE"] = "SIMILAR_PRODUCTS_PAGE";
        /**
         * The digest page is a regularly updated page dedicated for personalized and curated products
         */
        DisplayPage["DIGEST_PAGE"] = "DIGEST_PAGE";
        DisplayPage["DISCOVER_PAGE"] = "DISCOVER_PAGE";
        /**
         * Displays navigation links on mobile apps
         */
        DisplayPage["BROWSE_LANDING_PAGE"] = "BROWSE_LANDING_PAGE";
    })(DisplayPage = ILayoutElement.DisplayPage || (ILayoutElement.DisplayPage = {}));
    /**
     * Which platform to display the layout element.
     */
    let Platform;
    (function (Platform) {
        Platform["PLATFORM_UNKNOWN"] = "PLATFORM_UNKNOWN";
        /**
         * web regardless of viewport
         */
        Platform["WEB"] = "WEB";
        Platform["APP"] = "APP";
        /**
         * mobile web only
         */
        Platform["WEB_MOBILE"] = "WEB_MOBILE";
        /**
         * desktop web only
         */
        Platform["WEB_DESKTOP"] = "WEB_DESKTOP";
    })(Platform = ILayoutElement.Platform || (ILayoutElement.Platform = {}));
    let ITileCta;
    (function (ITileCta) {
        let ActionType;
        (function (ActionType) {
            /**
             * when ctaType == ActionType.DEFAULT, ctaValue should be "".
             * This is primarily for backward compatibility when ctaType is not recognized
             */
            ActionType["DEFAULT"] = "DEFAULT";
            /**
             * when ctaType == ActionType.APPLY_BRAND_CATEGORY, ctaValue should be one of the category
             */
            ActionType["APPLY_BRAND_CATEGORY"] = "APPLY_BRAND_CATEGORY";
        })(ActionType = ITileCta.ActionType || (ITileCta.ActionType = {}));
        /**
         * Return an instance of ITileCta with the provided fields. Any field not
         * listed will be populated with an empty value (an empty array,
         * or undefined, whichever is valid for the type of the value.)
         */
        ITileCta.build = (partial) => (Object.assign({}, (partial !== null && partial !== void 0 ? partial : {})));
    })(ITileCta = ILayoutElement.ITileCta || (ILayoutElement.ITileCta = {}));
    /**
     * Placement of layout elements on pages that have results (e.g. CATEGORY_PAGE)
     */
    let Placement;
    (function (Placement) {
        /**
         * @deprecated
         */
        Placement["TOP"] = "TOP";
        Placement["INLINE"] = "INLINE";
        Placement["BOTTOM"] = "BOTTOM";
        Placement["ABOVE_TITLE"] = "ABOVE_TITLE";
        Placement["BELOW_TITLE"] = "BELOW_TITLE";
        Placement["BELOW_BREADCRUMB"] = "BELOW_BREADCRUMB";
        Placement["TITLE_RIGHT"] = "TITLE_RIGHT";
        Placement["MOBILE_ABOVE_DESCRIPTION"] = "MOBILE_ABOVE_DESCRIPTION";
        Placement["MOBILE_TOP_FOOTER"] = "MOBILE_TOP_FOOTER";
        Placement["MOBILE_BELOW_DESCRIPTION"] = "MOBILE_BELOW_DESCRIPTION";
        Placement["ABOVE_FOOTER"] = "ABOVE_FOOTER";
    })(Placement = ILayoutElement.Placement || (ILayoutElement.Placement = {}));
    /**
     * Which page to display the layout element.
     */
    let PageVariant;
    (function (PageVariant) {
        PageVariant["PAGE_VARIANT_UNKNOWN"] = "PAGE_VARIANT_UNKNOWN";
        /**
         * show layout element on all pages
         */
        PageVariant["ALL"] = "ALL";
        /**
         * show layout element on first page
         */
        PageVariant["FIRST_PAGE"] = "FIRST_PAGE";
        /**
         * show layout element on odd page number pages i.e.: 1, 3, 5 etc.
         */
        PageVariant["ODD"] = "ODD";
        /**
         * show layout element on even page number pages i.e.: 2, 4, 6 etc.
         */
        PageVariant["EVEN"] = "EVEN";
    })(PageVariant = ILayoutElement.PageVariant || (ILayoutElement.PageVariant = {}));
    let IMilestoneInteraction;
    (function (IMilestoneInteraction) {
        let InteractionType;
        (function (InteractionType) {
            InteractionType["INTERACTION_TYPE_UNKNOWN"] = "INTERACTION_TYPE_UNKNOWN";
            InteractionType["RECORD_UPON_DISMISS"] = "RECORD_UPON_DISMISS";
            InteractionType["RECORD_UPON_SEEN"] = "RECORD_UPON_SEEN";
            InteractionType["RECORD_UPON_CLICK"] = "RECORD_UPON_CLICK";
        })(InteractionType = IMilestoneInteraction.InteractionType || (IMilestoneInteraction.InteractionType = {}));
        /**
         * Return an instance of IMilestoneInteraction with the provided fields. Any field not
         * listed will be populated with an empty value (an empty array,
         * or undefined, whichever is valid for the type of the value.)
         */
        IMilestoneInteraction.build = (partial) => (Object.assign({}, (partial !== null && partial !== void 0 ? partial : {})));
    })(IMilestoneInteraction = ILayoutElement.IMilestoneInteraction || (ILayoutElement.IMilestoneInteraction = {}));
    /**
     * Return an instance of ILayoutElement with the provided fields. Any field not
     * listed will be populated with an empty value (an empty array,
     * or undefined, whichever is valid for the type of the value.)
     */
    ILayoutElement.build = (partial) => (Object.assign({ images: [], tokens: [], layout_element_data: [], styles: {}, milestone_interactions: [], badges: [], tile_badges_map: {}, brands_by_token: {}, layout_element_data_assign_settings_on_client_view: [] }, (partial !== null && partial !== void 0 ? partial : {})));
})(ILayoutElement || (ILayoutElement = {}));
